export default {
  app: {
    tradeOffers: {
      country: '국가',
      loginPrompt: '비공개 제안을 확인하려면 {0}하세요.',
      logIn: '로그인',
    },
  },
};
